































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Mutation } from 'vuex-class';
import Modal from '../../Modal/Base3.vue';
import { Card, createToken } from 'vue-stripe-elements-plus';
import { Stripe, StripeError } from '@stripe/stripe-js';
import Brand from '@/services/Brand';
import jQuery from 'jquery';
import BillPay from '@/services/BillPay';
import Alert from '@/components/Global/Card.vue';

interface CardSetup {
	cardholderName: string;
	cardNumber: string;
	cardExpDate: string;
	cardCVV: string;
}

@Component({
	name: 'AddPaymentMethod',
	components: {
		Modal,
		Card,
		Alert,
	},
})
export default class AddPaymentMethod extends Vue {
	@Prop() private stripe: Stripe;
	@Mutation('addPaymentSource', { namespace: 'Payment' }) private addPaymentSource: (
		paymentSource,
	) => void;

	@Mutation('setPaymentSuccess', { namespace: 'Payment' }) private setPaymentSuccess: (
		payload,
	) => void;
	private error: boolean | string | StripeError = false;
	private selectPaymentMethod: 'card' | 'bank_account' = null;
	private cardholderName: string = '';
	private elementCard = null;
	private cardComplete: boolean = false;
	private authorizedToSubmit: boolean = false;
	private bankAccountSetup = {
		accountHolderType: '',
		accountHolderName: '',
		routingNumber: '',
		accountNumber: '',
	};
	private stripeKey: string = Brand.getStripeKey();
	private stripeOptions = {
		elements: {
			fonts: [
				{
					cssSrc: 'https://fonts.googleapis.com/css?family=Roboto:400,400i',
				},
			],
		},
		style: {
			base: {
				fontFamily: 'Roboto, sans-serif',
				fontSize: '16px',
				fontWeight: 400,
				iconColor: '#007698',
				color: '#495057',
			},
		},
	};

	private async addMethod(): Promise<void> {
		this.error = false;
		console.log('here');

		switch (this.selectPaymentMethod) {
			case 'card':
				await this.setupCard();
				break;

			case 'bank_account':
				await this.setupBankAccount();
				break;
		}
	}

	private async setupCard() {
		const checkNameRegex = new RegExp('^[a-zA-Z_0-9_. ]', '');

		let thenumbers = '';
		if (this.cardholderName.match(/\d+/)) {
			thenumbers = this.cardholderName.match(/\d+/)[0];
		}

		if (this.cardholderName.match(checkNameRegex) && thenumbers.length <= 5) {
			const { token, error } = await createToken({
				name: this.cardholderName,
			});

			if (error) {
				this.error = error.message;
				return;
			}

			const paymentSource = {
				exp_month: token.card.exp_month,
				exp_year: token.card.exp_year,
				id: token.id,
				last4: token.card.last4,
				type: 'card',
				verified: true,
			};

			this.sendSourceToBackend(paymentSource, token);
		} else {
			this.error =
				'Card holder name is invalid. It cannot contain more than 5 numbers and can only use alphanumberic characters.';
		}
	}

	private async setupBankAccount() {
		const bankInfo = {
			routing_number: this.bankAccountSetup.routingNumber,
			account_number: this.bankAccountSetup.accountNumber,
			account_holder_type: this.bankAccountSetup.accountHolderType,
			account_holder_name: this.bankAccountSetup.accountHolderName,
			country: 'US',
			currency: 'usd',
		};

		console.log(bankInfo);

		const { token, error } = await this.stripe.createToken('bank_account', bankInfo);

		console.log(token, error);

		if (error) {
			if (error?.message) {
				this.error = error.message;
			} else {
				this.error = error;
			}
			return;
		}

		const paymentSource = {
			id: token.id,
			last4: token.bank_account.last4,
			type: 'bank_account',
			verified: true,
		};

		this.sendSourceToBackend(paymentSource, token);
	}

	private async sendSourceToBackend(paymentSource, token) {
		// Push to Database
		const addPaymentMethod = await BillPay.addPaymentMethod({
			token,
			amount: 'due',
		});

		if (!addPaymentMethod.data.error) {
			// Add New Payment Method
			this.addPaymentSource(paymentSource);

			if (
				this.selectPaymentMethod === 'bank_account' ||
				this.selectPaymentMethod === 'card'
			) {
				this.$emit('update:alert', {
					type: 'success',
					title: 'Payment method added',
					msg: `Successfuly added - ${
						this.selectPaymentMethod === 'card' ? 'Card' : 'Bank Account'
					} ending in ${paymentSource.last4}`,
				});
			}
			jQuery('#addPaymentMethod').modal('hide');
			this.resetModal();
		} else {
			console.log(addPaymentMethod.data);
			this.error = addPaymentMethod.data.reason;
		}
	}

	private resetModal() {
		this.selectPaymentMethod = null;
		this.cardholderName = '';
		this.elementCard = null;
		this.cardComplete = false;
		this.authorizedToSubmit = false;
		this.bankAccountSetup = {
			accountHolderType: '',
			accountHolderName: '',
			routingNumber: '',
			accountNumber: '',
		};
	}

	private closeWindow() {
		jQuery('#addPaymentMethod').modal('hide');
	}
}
